import React, { memo } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Line, Wrap } from "./styles";

const AccordionComponent = ({ title, content }) => {
  if (content instanceof Object) {
    return (
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <MyTreeComponent data={content} />
        </AccordionDetails>
      </Accordion>
    );
  }

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <MyTreeComponent data={content} />
      </AccordionDetails>
    </Accordion>
  );
};

export const MyTreeComponent = ({ data }) => {
  if (data instanceof Array) {
    return (
      <Wrap>
        {data.map((item) => (
          <MyTreeComponent data={item} />
        ))}
      </Wrap>
    );
  }

  if (data instanceof Object) {
    return (
      <Wrap>
        {Object.keys(data).map((key) =>
          data[key] instanceof Array ? (
            <AccordionComponent title={key} content={data[key]} />
          ) : data[key] instanceof Object ? (
            <AccordionComponent title={key} content={data[key]} />
          ) : (
            <Line>
              <Typography
                mr={2}
                sx={{ fontWeight: "bold" }}
              >{`${key}: `}</Typography>
              {data[key]}
            </Line>
          )
        )}
      </Wrap>
    );
  }

  return null;
};

export const MyTree = memo(MyTreeComponent);
